import React from 'react'

export function getTspanGroups(value: string, labels: any) {
  if (!labels[value] || !labels[value]?.length) {
    return value
  }

  const children: JSX.Element[] = []
  let dy = 0

  labels[value].forEach((lineText, i) => {
    children.push(
      <tspan x={0} dy={dy} key={i}>
        {lineText}
      </tspan>,
    )

    //increment dy to render next line text below
    dy += 15

    if (dy > 15) {
      dy = 15
    }
  })

  return children
}
